import FullScreenLoader from "../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { useProperty } from "../PropertyContext";
import swal from "sweetalert";
import ThemeSettings from "../Property pages/commun/ThemeSettings";
import { TagsInput } from "react-tag-input-component";
import ReservationHeader from "./Commun/ReservationHeader";
import RservationSidebar from "./Commun/ReservationSidebar";
import { AddRoomDetails, GetResAgentList, GetResCorporatedetail, ReserBusinessSource, ReserGuaranteeCodes, ReserSaveBookingconfirm, ReservationMarketSegmentApi, ReservationMealplan, ReservationPreBooking, ReservationRateCode, ReservationRateCodeList } from "../Services/Service";


const Hotellist = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { selectedProperty } = useProperty();
  const propertyId = selectedProperty?.PropertyID;
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const [rateCodeID] = useState("1");
  const [totalRoom, setTotalRoom] = useState("1");
  const [roomDetails, setRoomDetails] = useState([]);
  const [rateCode, setRateCode] = useState("property");
  const [selectedAgent, setSelectedAgent] = useState("");
  const [selectedCorporate, setSelectedCorporate] = useState("");
  const [roomStates, setRoomStates] = useState({});
  const [addedRooms, setAddedRooms] = useState([]);
  const [rateCodes, setRateCodes] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [corporateList, setCorporateList] = useState([]);
  const [guaranteeCodes, setGuaranteeCodes] = useState([]);
  const [nights, setNights] = useState(0);
  const [mealplan, setMealplan] = useState([]);
  const [ratecode, setRatecode] = useState([]);
  const [marketSegment, setMarketSegment] = useState([]);
  const [businessSources, setBusinessSources] = useState([]);

  // const handleCheckInChange = (e) => {
  //   const selectedDate = e.target.value;
  //   setCheckIn(selectedDate);
  //   const nextDay = new Date(selectedDate);
  //   nextDay.setDate(nextDay.getDate() + 1);
  //   const formattedNextDay = nextDay.toISOString().split("T")[0];
  //   setCheckOut(formattedNextDay);
  // };

  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    setCheckIn(today.toISOString().split("T")[0]);
    setCheckOut(tomorrow.toISOString().split("T")[0]);
  }, []);

  const parseYMDToUTCDate = (ymd) => {
    if (!ymd) return null;
    const [y, m, d] = ymd.split("-").map(Number);
    return new Date(Date.UTC(y, m - 1, d));
  };

  // Safe formatter: Date -> "YYYY-MM-DD" using UTC date parts
  const formatDateToYMD = (date) => {
    const y = date.getUTCFullYear();
    const m = String(date.getUTCMonth() + 1).padStart(2, "0");
    const d = String(date.getUTCDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  // const handleCheckInChange = (e) => {
  //   const selectedDate = e.target.value;
  //   setCheckIn(selectedDate);

  //   const nextDay = new Date(selectedDate);
  //   nextDay.setDate(nextDay.getDate() + 1);

  //   const formattedNextDay = nextDay.toISOString().split("T")[0];
  //   setCheckOut(formattedNextDay);
  // };


  const handleCheckInChange = (e) => {
    const selectedDate = e.target.value; // "YYYY-MM-DD"
    setCheckIn(selectedDate);

    // parse as UTC midnight, add 1 day
    const inDate = parseYMDToUTCDate(selectedDate);
    if (!inDate) {
      setCheckOut("");
      return;
    }
    const nextDay = new Date(inDate.getTime() + 24 * 60 * 60 * 1000);
    setCheckOut(formatDateToYMD(nextDay));
  };

  // Recalculate nights whenever checkIn or checkOut change
  useEffect(() => {
    const inDate = parseYMDToUTCDate(checkIn);
    const outDate = parseYMDToUTCDate(checkOut);

    if (!inDate || !outDate) {
      setNights(0);
      return;
    }

    const msPerDay = 24 * 60 * 60 * 1000;
    const diff = Math.round((outDate - inDate) / msPerDay); // should be integer with UTC midnight
    setNights(diff > 0 ? diff : 0);
  }, [checkIn, checkOut]);



  useEffect(() => {
    const fetchAgentName = async () => {
      setLoading(true);
      try {
        const result = await GetResAgentList(selectedProperty?.PropertyID);
        if (Array.isArray(result)) {
          const filtered = result.filter((a) => a.TA_Name && a.AgentID);
          setAgentList(filtered);
        }
      } catch (error) {
        console.log("error get Agent Name", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAgentName();
  }, [selectedProperty]);

  useEffect(() => {
    const fetchCorporateDetail = async () => {
      setLoading(true);
      try {
        const result = await GetResCorporatedetail(selectedProperty?.PropertyID);
        if (Array.isArray(result)) {
          const filtered = result.filter(
            (corp) => corp.CorporateID && corp.TA_Name
          );
          setCorporateList(filtered);
        }
      } catch (error) {
        console.log("error get corporate detail", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCorporateDetail();
  }, [selectedProperty]);



  const handleSearch = useCallback(async () => {
    if (!checkIn || !checkOut) {
      swal("Please select Check-In and Check-Out dates.", {
        icon: "warning",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-warning",
          },
        },
      });
      return;
    }

    setLoading(true);
    try {
      const result = await ReservationPreBooking(
        // propertyId,
        selectedProperty?.PropertyID,
        checkIn,
        checkOut,
        rateCode,
        rateCodeID,
        totalRoom
      );
      const ratePlans = result?.RatePlan || [];
      setRoomDetails(ratePlans);

      const token = result?.RoomDetails?.[0]?.PreBookingToken;
      if (token) {
        localStorage.setItem("PreBookingToken", token);
      }

      const initialStates = {};
      ratePlans.forEach((room) => {
        initialStates[room.RoomID] = {
          selectedPlanID: null,
          roomQty: 1,
          adults: 1,
          children: 0,
          extraBeds: 0,
        };
      });
      setRoomStates(initialStates);
    } catch (error) {
      console.log("error fetching booking", error);
    } finally {
      setLoading(false);
    }
  }, [selectedProperty, checkIn, checkOut, rateCode, rateCodeID, totalRoom]);


  useEffect(() => {
    if (selectedProperty && checkIn && checkOut) {
      handleSearch();
    }
  }, [selectedProperty, checkIn, checkOut, handleSearch]);


  const updateRoomState = (roomId, key, value) => {
    setRoomStates((prev) => ({
      ...prev,
      [roomId]: {
        ...prev[roomId],
        [key]: value,
      },
    }));
  };

  const increment = (roomId, key) => {
    updateRoomState(roomId, key, roomStates[roomId][key] + 1);
  };

  const decrement = (roomId, key) => {
    if (roomStates[roomId][key] > 0) {
      updateRoomState(roomId, key, roomStates[roomId][key] - 1);
    }
  };


  // const handleAddRoom = async (room) => {
  //   const isAlreadyAdded = addedRooms.includes(room.RoomID);

  //   if (isAlreadyAdded) {
  //     // Remove room from addedRooms
  //     setAddedRooms(prev => prev.filter(id => id !== room.RoomID));
  //     swal("Room Removed!", "Room removed from booking.", "warning");
  //     return;
  //   }

  //   const roomState = roomStates[room.RoomID];
  //   const mealPlans = room.MealPlan ? JSON.parse(room.MealPlan) : [];
  //   const selectedPlan = mealPlans.find(p => p.RatePlanID === roomState.selectedPlanID);

  //   if (!selectedPlan) {
  //     swal("Please select a meal plan first.", {
  //       icon: "warning",
  //       buttons: {
  //         confirm: {
  //           text: "OK",
  //           className: "btn btn-warning",
  //         },
  //       },
  //     });
  //     return;
  //   }

  //   const token = localStorage.getItem("PreBookingToken");
  //   if (!token) {
  //     swal("PreBooking Token missing!", { icon: "error" });
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("PropertyID", propertyId);
  //   formData.append("ID", "0");
  //   formData.append("PreBookingToken", token);
  //   formData.append("RoomID", room.RoomID);
  //   formData.append("RatePlanID", selectedPlan.RatePlanID);
  //   formData.append("TotalRoom", roomState.roomQty || 1);
  //   formData.append("RoomRate", selectedPlan.PerRoomRate);
  //   formData.append("ExtraBed", roomState.extraBeds || 0);
  //   formData.append("ExtraBedAmount", selectedPlan.ExtraBedCharges || 0);
  //   formData.append("Adults", roomState.adults || 1);
  //   formData.append("Child", roomState.children || 0);
  //   formData.append("MealPlanID");

  //   setLoading(true);

  //   try {
  //     const result = await AddRoomDetails(formData);
  //     if (result?.message) {
  //       swal("Room Added!", result.message, "success");
  //     } else {
  //       swal("Room Added!", "Room successfully added.", "success");
  //     }

  //     setAddedRooms(prev => [...prev, room.RoomID]); // Mark as added
  //   } catch (err) {
  //     console.error("Add Room failed", err);
  //     swal("Failed to add room", { icon: "error" });
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const handleAddRoom = async (room) => {
    const isAlreadyAdded = addedRooms.includes(room.RoomID);

    if (isAlreadyAdded) {
      setAddedRooms(prev => prev.filter(id => id !== room.RoomID));
      swal("Room Removed!", "Room removed from booking.", "warning");
      return;
    }

    const roomState = roomStates[room.RoomID] || {};

    // --- Parse mealPlans from the room (if provided) ---
    const mealPlans = room.MealPlan ? JSON.parse(room.MealPlan) : [];

    // --- Find selectedPlan safely ---
    // We try multiple matching strategies so this works whether your select value is Code or RatePlanID.
    const selectedPlan =
      mealPlans.find(p => p.RatePlanID === roomState.selectedPlanID) ||
      mealPlans.find(p => p.Code === roomState.selectedMealPlan) ||
      mealPlans.find(p => p.RatePlanID === roomState.selectedMealPlan) ||
      null;

    // Validation: ensure user selected both rate code and meal plan (adjust messages if you use different fields)
    if (!roomState.selectedRateCode) {
      swal("Please select Rate Code first.", { icon: "warning" });
      return;
    }

    if (!roomState.selectedMealPlan) {
      swal("Please select Meal Plan first.", { icon: "warning" });
      return;
    }

    const token = localStorage.getItem("PreBookingToken");
    if (!token) {
      swal("PreBooking Token missing!", { icon: "error" });
      return;
    }

    const formData = new FormData();
    formData.append("PropertyID", propertyId);
    formData.append("ID", "0");
    formData.append("PreBookingToken", token);
    formData.append("RoomID", room.RoomID);

    // Append the selected values (these come from your selects)
    formData.append("RatePlanID", roomState.selectedRateCode);
    formData.append("MealPlanID", roomState.selectedMealPlan);

    // Use selectedPlan to fill these fields if available, otherwise fallback to 0
    formData.append("TotalRoom", roomState.roomQty || 1);
    formData.append("RoomRate", selectedPlan?.PerRoomRate ?? 0);
    formData.append("ExtraBed", roomState.extraBeds || 0);
    formData.append("ExtraBedAmount", selectedPlan?.ExtraBedCharges ?? 0);
    formData.append("Adults", roomState.adults || 1);
    formData.append("Child", roomState.children || 0);

    setLoading(true);

    try {
      const result = await AddRoomDetails(formData);
      swal("Room Added!", result?.message || "Room successfully added.", "success");
      setAddedRooms(prev => [...prev, room.RoomID]);
    } catch (err) {
      console.error("Add Room failed", err);
      swal("Failed to add room", { icon: "error" });
    } finally {
      setLoading(false);
    }
  };



  const [summary, setSummary] = useState({
    totalAmount: 0,
    taxPercent: 5,
    taxAmount: 0,
    totalAfterTax: 0,
  });

  useEffect(() => {
    let totalAmount = 0;

    addedRooms.forEach((roomId) => {
      const room = roomDetails.find((r) => r.RoomID === roomId);
      const roomState = roomStates[roomId] || {};
      const mealPlans = room?.MealPlan ? JSON.parse(room.MealPlan) : [];
      const selectedPlan = mealPlans.find(p => p.RatePlanID === roomState.selectedPlanID);
      const baseRate = selectedPlan?.PerRoomRate || 0;
      const extraRate = selectedPlan?.ExtraBedCharges || 0;

      const roomQty = roomState.roomQty || 1;
      const extraBeds = roomState.extraBeds || 0;

      // totalAmount += (roomQty * baseRate) + (extraBeds * extraRate);

      const lineAmount = roomState.customAmount !== undefined
        ? Number(roomState.customAmount)
        : (roomQty * baseRate) + (extraBeds * extraRate);

      totalAmount += lineAmount;
    });

    setSummary(prev => {
      const taxAmount = (totalAmount * prev.taxPercent) / 100;
      const totalAfterTax = totalAmount + taxAmount;
      return {
        ...prev,
        totalAmount,
        taxAmount,
        totalAfterTax,
      };
    });
  }, [addedRooms, roomStates, roomDetails, summary.taxPercent]);


  useEffect(() => {
    const perNightAmount = Number(summary.totalAmount || 0);
    const nightsCount = Number(nights || 0);

    // amount × nights
    const stayAmount = perNightAmount * nightsCount;

    // tax calc
    const taxAmount = (stayAmount * summary.taxPercent) / 100;

    // total after tax
    const totalAfterTax = stayAmount + taxAmount;

    setSummary(prev => ({
      ...prev,
      stayAmount,      // NEW: total for stay
      taxAmount,
      totalAfterTax
    }));
  }, [summary.totalAmount, nights]);


  const [formData, setFormData] = useState({
    Title: "Mr.",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    EmailAddress: [],
    Address: "",
    MobileNumber: "",
    Country: "",
    State: "",
    City: "",
    CompanyName: "",
    RegistrationNumber: "",
    RegistrationCompanyName: "",
    RegistrationCompanyAddress: "",
    BusSource: "",
    BillingInstruction: "",
    MarketSegment: "",
    GuaranteeCode: "",
    BookingComment: "",
    PaymentComment: "",
  });


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (
      !formData.Title ||
      !formData.FirstName?.trim() ||
      !formData.LastName?.trim() ||
      !formData.MobileNumber?.trim()
    ) {
      swal("Please Fill Guest Details", {
        icon: "warning",
        buttons: {
          confirm: { text: "OK", className: "btn btn-warning" },
        },
      });
      setLoading(false);
      return;
    }

    const payload = {
      PreBookingToken: localStorage.getItem("PreBookingToken"),
      // TotalRoomRate: summary.totalAmount,
      TotalRoomRate: summary.stayAmount,
      TotalExtraBedCharges: 0,
      TotalPayment: summary.totalAfterTax,
      Tax: summary.taxAmount,
      TotalAfterTax: summary.totalAfterTax,
      Discount: 0,
      ...formData,
    };

    try {
      await ReserSaveBookingconfirm(payload);
      swal("Your booking details submitted to Hotel!", {
        icon: "success",
        buttons: {
          confirm: { text: "OK", className: "btn btn-success" },
        },
      }).then((value) => {
        if (value) {
          navigate("/Reservation/BookingList", {
            state: { showSuccess: true },
          });
        }
      });
    } catch (error) {
      console.error("Booking failed:", error);
      swal("Booking Failed", {
        icon: "error",
        buttons: { confirm: { text: "OK", className: "btn btn-danger" } },
      });
    } finally {
      setLoading(false);
    }
  };


  // rate code list

  useEffect(() => {
    const FetchRateCode = async () => {
      try {
        const result = await ReservationRateCode();
        if (result && Array.isArray(result)) {
          setRateCodes(result);
        }
      }
      catch (error) {
        console.log("error get rate code in reservation booking", error);
      }
    }
    FetchRateCode();
  }, []);


  useEffect(() => {
    const fetchGuaranteeCodes = async () => {
      setLoading(true);
      try {
        const data = await ReserGuaranteeCodes(selectedProperty?.PropertyID);
        if (Array.isArray(data)) setGuaranteeCodes(data);
      } catch (error) {
        console.log("Error fetching business sources:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGuaranteeCodes();
  }, [selectedProperty]);


  useEffect(() => {
    const FetchMealplan = async () => {
      setLoading(true);
      try {
        const result = await ReservationMealplan(selectedProperty?.PropertyID);
        // if (Array.isArray(result)) setMealplan(result);
        if (Array.isArray(result)) setMealplan(result);
      }
      catch (error) {
        console.log("error get meal plan", error);
      } finally {
        setLoading(false);
      }
    }
    FetchMealplan();
  }, [selectedProperty]);


  useEffect(() => {
    const fetchRatecode = async () => {
      setLoading(true);
      try {
        const result = await ReservationRateCodeList(selectedProperty?.PropertyID);
        if (Array.isArray(result)) setRatecode(result);
      } catch (error) {
        console.log("error get rate code", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRatecode();
  }, [selectedProperty]);


  useEffect(() => {
    const FetchMArketSegment = async () => {
      setLoading(true);
      try {
        const result = await ReservationMarketSegmentApi(selectedProperty?.PropertyID);
        // setMarketSegment(result || []);
        if (Array.isArray(result)) setMarketSegment(result);
      }
      catch (error) {
        console.log("error fetching market segment", error);
      } finally {
        setLoading(false);
      }
    }
    FetchMArketSegment();
  }, [selectedProperty]);

  useEffect(() => {
    const fetchBusinessSource = async () => {
      setLoading(true);
      try {
        const data = await ReserBusinessSource(selectedProperty?.PropertyID);
        if (Array.isArray(data)) setBusinessSources(data);
      } catch (error) {
        console.log("Error fetching business sources:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBusinessSource();
  }, [selectedProperty]);


  return (
    <>
      {loading && (
        <FullScreenLoader />
      )}

      <div className="wrapper">
        <RservationSidebar />
        <div className="main-panel">
          {/* <Hearder /> */}
          <ReservationHeader />
          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="card mb-0 ">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Reservation Details</h4>
                    </div>
                    <div className="card-body">
                      <form >
                        <div className="row">

                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Arrival:</label>
                              <input
                                type="date"
                                className="form-control"
                                value={checkIn}
                                onChange={handleCheckInChange}
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Departure:
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                value={checkOut}
                                onChange={(e) => setCheckOut(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Nights
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={nights}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Rate Code:
                              </label>
                              <select className="form-control form-select" value={rateCode} onChange={(e) => setRateCode(e.target.value)}>
                                <option value="">Select Type</option>
                                {rateCodes.map((code) => (
                                  <option key={code.ID} value={code.RateCodeType.toLowerCase()}>
                                    {code.RateCodeType}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          {/* Travel Agent Dropdown */}
                          {rateCode === "travel agent" && (
                            <div className="col-md-3">
                              <div className="input-block mb-3">
                                <label className="col-form-label">Select Travel Agent:</label>
                                <select
                                  className="form-control form-select"
                                  value={selectedAgent}
                                  onChange={(e) => setSelectedAgent(e.target.value)}
                                >
                                  <option value="">Select Agent</option>
                                  {agentList.map((agent) => (
                                    <option key={agent.AgentID} value={agent.AgentID}>
                                      {agent.TA_Name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}

                          {/* Corporate Dropdown */}
                          {rateCode === "corporate" && (
                            <div className="col-md-3">
                              <div className="input-block mb-3">
                                <label className="col-form-label">Select Corporate:</label>
                                <select
                                  className="form-control form-select"
                                  value={selectedCorporate}
                                  onChange={(e) => setSelectedCorporate(e.target.value)}
                                >
                                  <option value="">Select Corporate</option>
                                  {corporateList.map((corp) => (
                                    <option key={corp.CorporateID} value={corp.CorporateID}>
                                      {corp.TA_Name} (CP_{corp.CorporateCode || "N/A"})
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}



                          <div className="col-md-1">
                            <div className="input-block mb-3">
                              <label className="col-form-label">(T) Room</label>
                              <select className="form-select form-control" value={totalRoom}
                                onChange={(e) => setTotalRoom(e.target.value)}>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-1" style={{ marginTop: "37px" }}>
                            <button className="btn btn-black" type="button" onClick={handleSearch}>Search</button>
                          </div>

                        </div>

                      </form>

                      {/* property rooom table */}
                      <div className="row">
                        <div className="col-md-12">
                          <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "auto" }}>
                            <table
                              className="display table table-striped table-bordered table-hover"
                            >
                              <thead style={{ position: "sticky", top: 0, background: "#f1f1f1", zIndex: 10 }}>
                                <tr>
                                  <th> Room Type </th>
                                  <th> ratecode & Plan </th>
                                  <th> Rooms </th>
                                  <th> Adult</th>
                                  <th> Child</th>
                                  <th> Extra Bed's</th>
                                  <th> Amount </th>
                                  <th> Action </th>
                                </tr>
                              </thead>
                              <tbody>
                                {roomDetails.length === 0 && (
                                  <tr>
                                    <td colSpan="9" className="text-center fw-bold" >No rooms found</td>
                                  </tr>
                                )}

                                {roomDetails.map((room) => {
                                  const roomState = roomStates[room.RoomID] || {};
                                  const mealPlans = room.MealPlan ? JSON.parse(room.MealPlan) : [];
                                  const selectedPlan = mealPlans.find(p => p.RatePlanID === roomState.selectedPlanID);
                                  const baseRate = selectedPlan?.PerRoomRate || 0;
                                  const extraRate = selectedPlan?.ExtraBedCharges || 0;
                                  const amount = (roomState.roomQty || 1) * baseRate + (roomState.extraBeds || 0) * extraRate;
                                  return (
                                    <tr key={room.RoomID}>

                                      <td> {room.RoomName} </td>
                                      <td>
                                        <select
                                          className="form-select mb-1"
                                          value={roomState.selectedRateCode || ""}
                                          onChange={(e) =>
                                            updateRoomState(room.RoomID, "selectedRateCode", e.target.value)
                                          }
                                        >
                                          <option value="">Select Rate code</option>
                                          {ratecode.map((item) => (
                                            <option key={item.RateCodeID} value={item.Code}>
                                              {item.Name}
                                            </option>
                                          ))}
                                        </select>


                                        <select
                                          className="form-select"
                                          value={roomState.selectedMealPlan || ""}
                                          onChange={(e) =>
                                            updateRoomState(room.RoomID, "selectedMealPlan", e.target.value)
                                          }
                                        >
                                          <option value="">Select Meal Plan</option>
                                          {mealplan.map((item) => (
                                            <option key={item.MealPlanID} value={item.Code}>
                                              {item.Name}
                                            </option>
                                          ))}
                                        </select>


                                      </td>

                                      <td>
                                        <div className="d-flex align-items-center justify-content-center">
                                          <button type="button" className="btn btn-outline-secondary btn-sm px-2 py-1 " onClick={() => decrement(room.RoomID, 'roomQty')}>
                                            <i className="fas fa-minus"></i>
                                          </button>
                                          <span className="mx-2">{roomState.roomQty || 1}</span>
                                          <button type="button" className="btn btn-outline-secondary btn-sm px-2 py-1" onClick={() => increment(room.RoomID, 'roomQty')}>
                                            <i className="fas fa-plus"></i>
                                          </button>
                                        </div>
                                      </td>

                                      {/* Adults */}
                                      <td >
                                        <div className="d-flex align-items-center justify-content-center">
                                          <button type="button" className="btn btn-outline-secondary btn-sm px-2 py-1" onClick={() => decrement(room.RoomID, 'adults')}>
                                            <i className="fas fa-minus"></i>
                                          </button>
                                          <span className="mx-2">{roomState.adults || 1}</span>
                                          <button type="button" className="btn btn-outline-secondary btn-sm px-2 py-1" onClick={() => increment(room.RoomID, 'adults')}>
                                            <i className="fas fa-plus"></i>
                                          </button>
                                        </div>
                                      </td>

                                      {/* Child */}
                                      <td >
                                        <div className="d-flex align-items-center justify-content-center">
                                          <button type="button" className="btn btn-outline-secondary btn-sm px-2 py-1" onClick={() => decrement(room.RoomID, 'children')}>
                                            <i className="fas fa-minus"></i>
                                          </button>
                                          <span className="mx-2">{roomState.children || 0}</span>
                                          <button type="button" className="btn btn-outline-secondary btn-sm px-2 py-1" onClick={() => increment(room.RoomID, 'children')}>
                                            <i className="fas fa-plus"></i>
                                          </button>
                                        </div>
                                      </td>

                                      {/* Extra Bed */}
                                      <td >
                                        <div className="d-flex align-items-center justify-content-center">
                                          <button type="button" className="btn btn-outline-secondary btn-sm px-2 py-1" onClick={() => decrement(room.RoomID, 'extraBeds')}>
                                            <i className="fas fa-minus"></i>
                                          </button>
                                          <span className="mx-2">{roomState.extraBeds || 0}</span>
                                          <button type="button" className="btn btn-outline-secondary btn-sm px-2 py-1" onClick={() => increment(room.RoomID, 'extraBeds')}>
                                            <i className="fas fa-plus"></i>
                                          </button>
                                        </div>
                                      </td>

                                      {/* <td>₹ {amount}</td> */}

                                      {/* Amount (editable) */}
                                      <td>
                                        <div className="input-group" style={{ maxWidth: "160px", margin: "0 auto" }}>
                                          <span className="input-group-text">₹</span>
                                          <input
                                            type="number"
                                            className="form-control"
                                            step="0.01"
                                            min="0"
                                            value={roomState.customAmount !== undefined ? roomState.customAmount : amount}
                                            onChange={(e) =>
                                              updateRoomState(
                                                room.RoomID,
                                                "customAmount",
                                                e.target.value === "" ? undefined : Number(e.target.value)
                                              )
                                            }
                                          />
                                        </div>
                                      </td>


                                      <td className="text-center">
                                        <button
                                          className={`btn btn-sm ${addedRooms.includes(room.RoomID) ? "btn-danger" : "btn-black"}`}
                                          type="button"
                                          onClick={() => handleAddRoom(room)}
                                        // disabled={!roomState.selectedPlanID}
                                        >
                                          {addedRooms.includes(room.RoomID) ? "Delete" : "Add"}
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>

                            </table>
                          </div>
                        </div>
                      </div>


                      <div className="m-1 mt-4">
                        <div className="border bg-gray1 rounded-2 position-relative">
                          <h6
                            className="fw-bold position-absolute"
                            style={{ top: "-12px", paddingInline: "8px", backgroundColor: "#f5f7fd ", left: "5px", borderRadius: "4px" }}
                          >
                            Total Amount{" "}
                          </h6>
                          <div className="row align-items-end p-3">
                            <div className="col-auto">
                              <div className="input-block">
                                <label className="col-form-label"> Amount</label>
                                <input type="number" className="form-control" value={summary.stayAmount?.toFixed(2)} readOnly />
                              </div>
                            </div>

                            <div className="col-auto d-flex align-items-end pb-1">
                              <span className="fw-bold fs-3">+</span>
                            </div>

                            <div className="col-auto">
                              <div className="input-block">
                                <div className="d-flex gap-2 mb-1">
                                  <label className="col-form-label"> Tax </label>
                                  <select
                                    style={{ width: "74px", marginTop: " 4px" }}
                                    className="form-control form-select"
                                    value={summary.taxPercent}
                                    onChange={(e) =>
                                      setSummary(prev => ({ ...prev, taxPercent: Number(e.target.value) }))
                                    }
                                  >
                                    <option value={5}>5%</option>
                                    <option value={18}>18%</option>
                                  </select>
                                </div>
                                <input type="number" className="form-control " value={Number(summary.taxAmount || 0).toFixed(2)} readOnly />
                              </div>
                            </div>

                            <div className="col-auto d-flex align-items-end pb-1">
                              <span className="fw-bold fs-3">=</span>
                            </div>

                            <div className="col-auto">
                              <div className="input-block">
                                <label className="col-form-label"> Total Amount After Tax</label>
                                <input type="text" className="form-control" value={Number(summary.totalAfterTax || 0).toFixed(2)} readOnly />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                      {/* guest details table */}
                      <div className="col-md-12">
                        <h4 className="mt-3">Guest Details:</h4>
                        <div className="table-responsive">
                          <table
                            // id="basic-datatables"
                            className="display table table-striped table-bordered table-hover"
                          // style={{ width: "100%", tableLayout: "auto", whiteSpace: "nowrap", }}
                          >
                            <thead>
                              <tr>
                                <th style={{ backgroundColor: "rgb(213 222 254)", }}> Title </th>
                                <th style={{ backgroundColor: "rgb(213 222 254)", }}>First Name</th>
                                <th style={{ backgroundColor: "rgb(213 222 254)", }}> Last Name </th>
                                <th style={{ backgroundColor: "rgb(213 222 254)", }}> Contact No</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <select className="form-control form-select" value={formData.Title}
                                    onChange={(e) => setFormData({ ...formData, Title: e.target.value })}>
                                    <option >Select Prefix</option>
                                    <option>Mr.</option>
                                    <option>Mrs.</option>
                                    <option>Ms.</option>
                                    <option>Dr.</option>
                                  </select>
                                </td>
                                <td><input className="form-control" type="text" placeholder="Enter First Name" value={formData.FirstName}
                                  onChange={(e) => setFormData({ ...formData, FirstName: e.target.value })} /></td>
                                <td><input className="form-control" type="text " placeholder="Enter Last Name" value={formData.LastName}
                                  onChange={(e) => setFormData({ ...formData, LastName: e.target.value })} /></td>
                                <td><input className="form-control" type="number" placeholder="Enter number" value={formData.MobileNumber}
                                  onChange={(e) => setFormData({ ...formData, MobileNumber: e.target.value })} /></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="row">

                        <div className="col-md-4">
                          <div className="input-block ">
                            <label className="col-form-label">Email:</label>
                            {/* <input type="email" className="form-control" placeholder="Enter Email" value={formData.EmailAddress}
                              onChange={(e) => setFormData({ ...formData, EmailAddress: e.target.value })} /> */}
                            <TagsInput
                              value={Array.isArray(formData.EmailAddress) ? formData.EmailAddress : []}
                              onChange={(emails) => setFormData({ ...formData, EmailAddress: emails })}
                              name="emails"
                              placeHolder="Enter email and press Enter"
                            />
                            <div className="form-check d-flex">
                              <input className="form-check-input" type="checkbox" />
                              <label className="form-check-label" >
                                Do want to receive Booking Voucher on email ?
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-block">
                            <label className="col-form-label">Address</label>
                            <textarea type="text" className="form-control" placeholder="Enter Address" value={formData.Address}
                              onChange={(e) => setFormData({ ...formData, Address: e.target.value })} />
                          </div>
                        </div>
                        <div className="col-md-2 ">
                          <div className="input-block">
                            <label className="col-form-label">City</label>
                            <input type="text" className="form-control" placeholder="Enter City" value={formData.City}
                              onChange={(e) => setFormData({ ...formData, City: e.target.value })} />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="input-block">
                            <label className="col-form-label">Country</label>
                            <input type="text" className="form-control" placeholder="Enter Country" value={formData.Country}
                              onChange={(e) => setFormData({ ...formData, Country: e.target.value })} />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="input-block">
                            <label className="col-form-label">State</label>
                            <input type="text" className="form-control" placeholder="Enter State" value={formData.State}
                              onChange={(e) => setFormData({ ...formData, State: e.target.value })} />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="input-block">
                            <label className="col-form-label"> Company Name</label>
                            <input type="text" className="form-control" placeholder="Enter Company Name" value={formData.CompanyName}
                              onChange={(e) => setFormData({ ...formData, CompanyName: e.target.value })} />
                          </div>
                        </div>
                      </div>

                      <div className="m-1 mt-4">
                        <div className="border bg-gray1 rounded-2 position-relative">
                          <h6 className=" fw-bold position-absolute bg-gray1" style={{ top: "-12px", left: "12px", paddingInline: "4px", borderRadius: "4px" }}>
                            Enter GST Details (Optional)
                          </h6>
                          <div className="row p-3">
                            <div className="col-md-4 ">
                              <div className="input-block">
                                <label className="col-form-label">
                                  Registration Number
                                </label>
                                <input type="text" className="form-control" placeholder="Enter Registration Number" value={formData.RegistrationNumber}
                                  onChange={(e) => setFormData({ ...formData, RegistrationNumber: e.target.value })} />
                              </div>
                            </div>
                            <div className="col-md-4 ">
                              <div className="input-block">
                                <label className="col-form-label">
                                  Registered Company name
                                </label>
                                <input type="text" className="form-control" placeholder="Enter Registred Company Name" value={formData.RegistrationCompanyName}
                                  onChange={(e) => setFormData({ ...formData, RegistrationCompanyName: e.target.value })} />
                              </div>
                            </div>
                            <div className="col-md-4 ">
                              <div className="input-block">
                                <label className="col-form-label">
                                  Registered Company address
                                </label>
                                <textarea type="text" className="form-control" placeholder="Registered Company Address" value={formData.RegistrationCompanyAddress}
                                  onChange={(e) => setFormData({ ...formData, RegistrationCompanyAddress: e.target.value })} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-3">
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              Billing Instructions:
                            </label>
                            <select className="form-select form-control" value={formData.BillingInstruction}
                              onChange={(e) => setFormData({ ...formData, BillingInstruction: e.target.value })}>
                              <option>Select Billing Instruction</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="input-block mb-3">
                            <label className="col-form-label">  Market Segment </label>
                            <select className="form-select form-control" value={formData.MarketSegment}
                              onChange={(e) => setFormData({ ...formData, MarketSegment: e.target.value })}>
                              <option>Select</option>
                              {marketSegment?.map((seg) => (
                                <option key={seg.ID} value={seg.Code}>
                                  {seg.MarketSeg}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              Business Source:
                            </label>
                            <select className="form-select form-control" value={formData.BusSource}
                              onChange={(e) => setFormData({ ...formData, BusSource: e.target.value })}>
                              <option>Select</option>
                              {businessSources?.map((src) => (
                                <option key={src.ID} value={src.Code}>
                                  {src.BusinessSource}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              Guarantee Codes
                            </label>
                            <select className="form-select form-control" value={formData.GuaranteeCode}
                              onChange={(e) => setFormData({ ...formData, GuaranteeCode: e.target.value })}>
                              <option>Select</option>
                              {guaranteeCodes.map((item) => (
                                <option key={item.ID} value={item.Code}>
                                  {item.guaranteeCodes}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="ïnput-block mb-3">
                            <label className="col-from-lable">
                              Booking Comment
                            </label>
                            <textarea className="form-control" placeholder="Special Requriment" value={formData.BookingComment}
                              onChange={(e) => setFormData({ ...formData, BookingComment: e.target.value })}></textarea>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="ïnput-block mb-3">
                            <label className="col-from-lable">
                              Payment Comment
                            </label>
                            <textarea className="form-control" placeholder="Payment Comment" value={formData.PaymentComment}
                              onChange={(e) => setFormData({ ...formData, PaymentComment: e.target.value })}></textarea>
                          </div>
                        </div>
                      </div>


                      {/* <!-- Submit Button --> */}
                      <div className="card-action text-end">
                        <button type="submit" className="btn btn-black" onClick={handleSubmit}>
                          Submit
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Hotellist;
